export const splitTextByLinks = (text = '', linksFromText) => {
    const escapeRegex = linksFromText === null || linksFromText === void 0 ? void 0 : linksFromText.map((str) => str.replace(/[/.*+?^${}()|[\]\\]/g, '\\$&'));
    const sortedRegexQuery = escapeRegex === null || escapeRegex === void 0 ? void 0 : escapeRegex.sort((a, b) => b.length - a.length);
    const linkMatcherRegex = new RegExp(`(${sortedRegexQuery === null || sortedRegexQuery === void 0 ? void 0 : sortedRegexQuery.join('|')})`, 'i');
    return text.split(linkMatcherRegex).filter(Boolean);
};
//# sourceMappingURL=split-text-by-links.js.map